/**
 * Sidebar categories, derived from the toolkits actually in the catalogue.
 *
 * Not from `/connections/toolkits/categories`: that lists every category the
 * provider knows, most of which no toolkit here carries, so those filters
 * emptied the grid. Deriving them means every option returns something, and
 * the list is as short as the catalogue really is.
 *
 * Ordered by how many apps carry them — a sidebar sorted alphabetically buries
 * the categories anyone actually wants under the long tail.
 *
 * @param {{ categories?: Array<{ slug?: string, name?: string } | string> }[]} cards
 * @returns {{ id: string, label: string, count: number }[]}
 */
export function toolkitCategoryOptions(cards) {
  const byId = new Map()

  for (const card of cards ?? []) {
    for (const entry of card?.categories ?? []) {
      const id = String((typeof entry === 'string' ? entry : entry?.slug) ?? '')
        .trim()
        .toLowerCase()
      if (!id) continue
      const label = String((typeof entry === 'string' ? entry : entry?.name) || id)
      const existing = byId.get(id)
      if (existing) existing.count += 1
      else byId.set(id, { id, label, count: 1 })
    }
  }

  return [...byId.values()].sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
}
